import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716a5720"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "AListaDeItens",
  "data-testid": "AListaDeItens"
}
const _hoisted_2 = ["onClick", "title"]
const _hoisted_3 = { class: "quebrar-texto-em-duas-linhas" }

import { EntidadeSimples } from "@/types/gerais"
  import { computed, onMounted, onUnmounted } from "vue"
  import { usarRolagemInfinita } from "@/composable/UsarRolagemInfinita/usarRolagemInfinita"
  import { useI18n } from "vue-i18n"

  interface Props {
    itens: EntidadeSimples[]
    idItemSelecionado: string
    buscarMaisItens?: () => void
  }

  interface Emissoes {
    (event: "update:idItemSelecionado", item: string): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AListaDeItens',
  props: {
    itens: null,
    idItemSelecionado: null,
    buscarMaisItens: null
  },
  emits: ["update:idItemSelecionado"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:idItemSelecionado", item: string): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    itens: EntidadeSimples[]
    idItemSelecionado: string
    buscarMaisItens?: () => void
  }

  
  

  const { t } = useI18n()

  const { adicionarEventoDeRolagem, removerEventoDeRolagem } =
    usarRolagemInfinita({
      querySelecaoListaDeItens: ".AListaDeItens",
      atrasoRolagemInfinita: 400,
      buscarMaisItens: props.buscarMaisItens,
    })

  const definirItemSelecionado = (item: EntidadeSimples): void => {
    emitirItemSelecionado.value = item.id
  }

  const emitirItemSelecionado = computed({
    get() {
      return props.idItemSelecionado
    },
    set(itemSelecionado: string) {
      emitir("update:idItemSelecionado", itemSelecionado)
    },
  })

  const classeCssItemSelecionado = computed(() => {
    return (idItem: string): string => {
      return props.idItemSelecionado === idItem
        ? "AListaDeItens__Item--Selecionado"
        : ""
    }
  })

  const definirItensDaLista = (itens: EntidadeSimples[]): EntidadeSimples[] => {
    const itensComTodos = itens
    if (itensComTodos[0]?.id !== "sem-grupo") {
      itensComTodos.unshift({
        id: "sem-grupo",
        nome: t("verTodosOsProjetos"),
      })
    }
    return itensComTodos
  }

  onMounted(() => {
    adicionarEventoDeRolagem()
  })

  onUnmounted(() => {
    removerEventoDeRolagem()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definirItensDaLista(__props.itens), (item) => {
      return (_openBlock(), _createElementBlock("button", {
        onClick: ($event: any) => (definirItemSelecionado(item)),
        key: item.id,
        class: _normalizeClass(["AListaDeItens__Item", _unref(classeCssItemSelecionado)(item.id)]),
        "data-testid": "AListaDeItens__Item",
        title: item.nome
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.nome), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})